// config.js
const isDevelopment = process.env.NODE_ENV === 'development';

const config = {
  apiUrl: isDevelopment ? 'http://localhost:4002' : 'https://api.delire.net',
  isDev:isDevelopment,
  hostUrl: isDevelopment ? 'http://localhost:3000' : 'https://delire.net',

};

export default config;
